import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
export var getCookie = function (name) {
  var match = document.cookie.match(new RegExp("(^| )".concat(name, "=([^;]+)")));
  return match ? match[2] : null;
};
export var setCookie = function (key, value) {
  document.cookie = "".concat(key, "=").concat(value, ";path=/");
};